module.exports = __webpack_public_path__ + "img/klinisia logo final 1.177ca939.png";